import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchSaloons } from '../../../redux/action/saloons/saloons'
import DashboardContent from '../../dashboardWrapper/DashboardContent'
import Wrapper from '../../dashboardWrapper/Wrapper'
import NewSaloon from './newSaloon/NewSaloon'
import Saloons from './saloons/Saloons'

const DashboardSaloons = () => {
    const [forceUpdate, setForceUpdate] = useState(0)
    const saloons = useSelector(state => state.saloons)
    const dispatch = useDispatch()

    const update = () => {
        setForceUpdate(forceUpdate => forceUpdate+1)
    }

    useEffect(() => {
        dispatch(fetchSaloons())
    }, [forceUpdate])

    return (
        <Wrapper>
            <DashboardContent>
                <Saloons update={update} data={saloons} /> 
                <NewSaloon update={update} />
            </DashboardContent>
        </Wrapper>
    )
}

export default DashboardSaloons
